import { PageHeader } from '@shared/components';

import { useQSetSimilarityCheckResultDetails } from '../../providers';

export default function QSetSimilarityResultDetailsPageHeader() {
  const { qSetACode, qSetBCode } = useQSetSimilarityCheckResultDetails();
  return <PageHeader title={`ชุดข้อสอบ ${qSetACode} กับ ชุดข้อสอบ ${qSetBCode}`} />;
}
